/**
 * Mobile GO! - JavaScript personalizado.
 * (Ganchos del tema: 'variant:changed', 'product:added', 'cart:refresh'.)
 */

(function () {
  function traducir() {
    document.querySelectorAll('[title^="Show articles tagged"]').forEach(function (el) {
      el.setAttribute('title', el.getAttribute('title').replace('Show articles tagged', 'Ver artículos de'));
    });
    document.querySelectorAll('[title^="Show products tagged"]').forEach(function (el) {
      el.setAttribute('title', el.getAttribute('title').replace('Show products tagged', 'Ver productos de'));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', traducir);
  } else {
    traducir();
  }
})();
